import React from 'react'
import { useRouteMatch, Switch } from 'react-router-dom';
import { Route } from 'react-router-dom/cjs/react-router-dom.min';
import Leadership from './Leadership/Leadership';

function Podcasts() {
  const { url } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${url}/leadership`} component={Leadership} />
    </Switch>
  )
}

export default Podcasts